import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';

export const NavBarApi = Symbol('NavBarApi');
export interface NavBarApi {
    onClickNewTask(): void;
}

@injectable()
export class NavBarApiImpl extends PsHttpService implements NavBarApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    /**
     * 点击新任务按钮
     * 跳转到创建新任务的页面
     */
    onClickNewTask(): void {
        window.location.href = '/ls';
    }
}
